module.exports = {
  PORT: process.env.PORT || 8000,
  API_TOKEN: process.env.REACT_APP_API_TOKEN,
  API_BASE_URL: "https://sheltered-reef-55239.herokuapp.com/api",
  TOKEN_KEY: "bap-tracker-token",
};
